export const STATUS_KREIRAN = 0
export const STATUS_U_TOKU = 1
export const STATUS_ZAVRSEN = 2
export const STATUS_OTKAZAN = 3

export const PRIORITET_NORMAL = 0
export const PRIORITET_VISOK = 1
export const PRIORITET_HITNO = 2

export const PLAVI_NALOG_STATUSI = [
    {value: STATUS_KREIRAN, label: 'Kreiran', badge: 'secondary'},
    {value: STATUS_U_TOKU, label: 'U toku', badge: 'primary'},
    {value: STATUS_ZAVRSEN, label: 'Završen', badge: 'success'},
    {value: STATUS_OTKAZAN, label: 'Otkazan', badge: 'danger'},
]

export const PLAVI_NALOG_PRIORITETI = [
    {value: PRIORITET_NORMAL, label: 'Normal'},
    {value: PRIORITET_VISOK, label: 'Visok'},
    {value: PRIORITET_HITNO, label: 'Hitno'},
]

export interface PlaviNalogArtikal {
    Id?: number
    id?: number
    ArtNaziv?: string
    Naziv?: string
    ArtSifra?: string
}

export interface PlaviNalog {
    id: number
    brojNaloga: string
    idArtikal: number
    artikal?: PlaviNalogArtikal
    kolicina: number
    planiraniPocetak?: string
    planiraniKraj?: string
    status: number
    prioritet?: number
    napomena?: string
    planiranaKolicina?: number | string
    zavrsenaKolicina?: number | string
    operacije?: PlaviNalogOperacija[]
    nalogKontrolisao?: number
    nalogKontrolisaoKomentar?: string
    nalogUredan?: boolean | number
    ulazArtiklaId?: number | string
    kontrolisao?: {
        UposlenikImePrezime?: string
    }
    nalogKontrolisaoUposlenik?: {
        UposlenikImePrezime?: string
    }
    uposlenikKontrolisao?: {
        UposlenikImePrezime?: string
    }
}

export interface PlaviNalogFormModel {
    brojNaloga: string
    idArtikal: string | number
    kolicina: string | number
    planiraniPocetak: string
    planiraniKraj: string
    prioritet: string | number
    napomena: string
}

export interface PlaviNalogParams {
    per_page: number
    page: number
    brojNaloga?: string
    status?: string | number
    idArtikal?: string | number
}

export interface PlaviNalogRadniciParams {
    per_page: number
    page: number
    idOperacije?: string | number
    idUposlenik?: string | number
    kvar?: string | number | boolean
}

export interface PlaviNalogOperacija {
    id: number
    idOperacije?: number
    operacija?: {
        id?: number
        naziv?: string
        norma?: number
        normaMinuta?: number
        brojOperacija?: number
    }
    naziv?: string
    nazivOperacije?: string
    norma?: number
    normaMinuta?: number
    brojOperacija?: number
    planiranaKolicina?: number
    zavrsenaKolicina?: number
    planiranoVrijeme?: number | string
    stvarnoVrijeme?: number | string
    planiranoVrijemeMinuta?: number | string
    stvarnoVrijemeMinuta?: number | string
    status?: number
}

export interface PlaviNalogRadnik {
    id?: number
    radnik?: {
        UposlenikImePrezime?: string
    } | string
    uposlenik?: {
        UposlenikImePrezime?: string
    }
    sredstva?: {
        SredstvoNaziv?: string
    }
    UposlenikImePrezime?: string
    operacija?: {
        id?: number | string
        naziv?: string
        norma?: number | string
        normaMinuta?: number | string
        brojOperacija?: number | string
    } | string
    operacije?: {
        id?: number | string
        naziv?: string
        norma?: number | string
        normaMinuta?: number | string
        brojOperacija?: number | string
    }
    idOperacije?: number | string
    nazivOperacije?: string
    vrijeme?: number | string
    radnoVrijeme?: number | string
    stvarnoVrijeme?: number | string
    trajanje?: number | string
    startTime?: number | string
    endTime?: number | string
    kvar?: number | boolean
    prijavaKvaradId?: number | string
    prijavaKvaraId?: number | string
    kolicina?: number | string
    norma?: number | string
    normaMinuta?: number | string
    brojOperacija?: number | string
    ucinkovitost?: number | string
    učinkovitost?: number | string
    realizacija?: number | string
}

export interface PlaviNalogOperationWorker {
    idUposlenik: number
    brojPrijava: number
    ukupnoKomada: number
    ukupnoTrajanjeSekundi: number
    ukupnoVrijemeMinuta: number
    ukupnoVrijeme: string
    prosjecnaUcinkovitost: number
    brojKvarova: number
    zadnjaAktivnost?: string
    uposlenik?: {
        UposlenikImePrezime?: string
    }
}

export interface PlaviNalogAnalyticsOperation {
    idOperacije: number
    operacija: string
    komada: number
    vrijeme: string
    prosjecnaUcinkovitost: number
    brojPrijava?: number
    brojOperacija?: number | string
}

export interface PlaviNalogProductionAnalytics {
    idUposlenik: number
    ime: string
    ukupnoKomada: number
    ukupnoVrijeme: string
    ukupnoVrijemeMinuta: number
    brojOperacija: number
    brojPrijava: number
    prosjecnaUcinkovitost: number
    operacije: PlaviNalogAnalyticsOperation[]
}

export const getPlaviNalogStatus = (status?: number) =>
    PLAVI_NALOG_STATUSI.find((item) => item.value === status) ?? PLAVI_NALOG_STATUSI[0]

export const getPlaviNalogPrioritet = (prioritet?: number) =>
    PLAVI_NALOG_PRIORITETI.find((item) => item.value === prioritet) ?? PLAVI_NALOG_PRIORITETI[0]
